import Vue from 'vue'

export default {
  methods: {
    getLangFromCookies: function () {
      if (typeof Vue === 'object' && typeof Vue.$cookies === 'object' && typeof Vue.$cookies.get === 'function') {
        return Vue.$cookies.get('Language')
      }
      if (document.cookie) {
        const languageCookie = document.cookie.split(';').map(v => v.split('='))
          .find(([key]) => decodeURIComponent(key.trim()) === 'Language')
        if (Array.isArray(languageCookie)) {
          const [, value] = languageCookie
          const trimmedValue = value.trim()
          if (trimmedValue) {
            return decodeURIComponent(trimmedValue)
          }
        }
      }
      return 'en'
    }
  }
}
